import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export const HowItWorks: React.FC = () => {
  const steps = [{
    number: '1',
    title: 'Compra y recibe en 5 minutos',
    description: 'Completa tu pago seguro y recibirás el PDF y el Audio en tu correo de forma inmediata.'
  }, {
    number: '2',
    title: 'Lee y escucha en 15 minutos',
    description: 'Aplica el Método MRA con el manual y calibra tu voz con el audio de entrenamiento.'
  }, {
    number: '3',
    title: 'Entra a la embajada con certeza',
    description: 'Usa el protocolo en tu cita y responde con la seguridad de quien sabe exactamente qué decir.'
  }];
  return <SectionWrapper data-id="element-121">
      <div className="max-w-5xl mx-auto" data-id="element-122">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center" data-id="element-123">
          Cómo funciona
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8" data-id="element-124">
          {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center md:items-start md:text-left relative" data-id="element-125">
              {/* Connector line for desktop */}
              {index < steps.length - 1 && <div className="hidden md:block absolute top-10 left-[60%] w-[80%] h-[2px] bg-gray-800 -z-10" data-id="element-126"></div>}

              <div className="text-6xl font-black text-gold mb-6 opacity-90" data-id="element-127">
                {step.number}
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-white mb-4" data-id="element-128">
                {step.title}
              </h3>
              <p className="text-lg text-gray-300 leading-relaxed" data-id="element-129">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
};